import { AuthFlowType } from 'typings/Auth'

// Number of cards to render in account dashboard
export const BATCH_SIZE = 12

// Used to differentiate the authflows for ssn+phone sign in and revolving account sign in
export const UPAG_AUTH_FLOW = 'guestpay'
export const PAYLATER_AUTH_FLOW = 'paylater'
export const UNIVERSAL_ACTIVATION_FLOW = 'activate'
export const SECURED_INSTALLMENTS_FLOW = 'securedinstallments'
export const DEFAULT_AUTH_FLOW = PAYLATER_AUTH_FLOW
export const AUTH_FLOWS: AuthFlowType[] = [
  UPAG_AUTH_FLOW,
  PAYLATER_AUTH_FLOW,
  UNIVERSAL_ACTIVATION_FLOW,
  SECURED_INSTALLMENTS_FLOW
]
// Activation Flow Steps
export const CARD_INPUT = 'CARD_INPUT'
export const MERCHANT_LOOKUP = 'MERCHANT_LOOKUP'
export const UNIVERSAL_ACTIVATION = 'UNIVERSAL_ACTIVATION'

// identifies peaks manually logged events for new relic
export const NEW_RELIC_MANUAL_EVENT = 'MANUAL_LOG_EVENT'

// Format for masked and not masked inputs
export const INPUT_FORMATS = {
  ACCOUNT_NUMBER: '0000000000000000',
  CREDIT_CARD: '0000 0000 0000 0000',
  SECURITY_CODE: '000',
  PHONE_NUMBER: '(000) 000-0000',
  SSN: '0000',
  ZIP_CODE: '00000'
}

// Number of characters accepted on sign in forms
export const INPUT_LIMITS = {
  ACCOUNT_NUMBER: 16,
  CREDIT_CARD: 16,
  SECURITY_CODE: 3,
  PHONE_NUMBER: 10,
  SSN: 4,
  ZIP_CODE: 5
}

// REGEX to filter non digit characters from a string
export const FILTER_NON_DIGITS_REGEX = /[^0-9]/g

// REGEX to check if string is only non-digits
export const CHECK_NON_DIGITS_REGEX = /^[^\d]+$/

// class name to fix alignment of helper text inputs on error
export const HELPER_TEXT_ERROR_ALIGNMENT = 'helper-error-alignment'

// standardize synchrony homepage base url for any links redirected to synchrony pages
export const SYF_HOME_BASE_URL = 'https://www.synchrony.com/'

// find account url for universal activation flow
export const SYF_FIND_ACCOUNT_URL = `${SYF_HOME_BASE_URL}help/find-account`
